import React, { useEffect, useState, useCallback } from "react";
import { Link ,useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import config from "../../config/config";
const Property = () => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
    const [bannerData, setBannerData] = useState([]);
  const getList = useCallback(async () => {
    try {
      setLoading(true);
      const result = await config.getAllProperties();
      setProperties(result.data || []); // ✅ Update state (not local variable)
      setError(null);
    } catch (err) {
      setProperties([]);
      setError(null); // Silently fail
    } finally {
      setLoading(false);
    }
  }, []);

  const navigate = useNavigate();

  const detailPage = (id) => {
    // console.log("id=",id);
    
    navigate("/property/"+id+""); // 👈 redirects to /contact route
  };

  // ✅ Run only once
  useEffect(() => {
    getList();
    banner();
  }, []);
let banner = async () => {
  const result = await config.getBannerByName("home");
  setBannerData(result.data || {});
};
const heroStyle = bannerData
  ? {
      backgroundImage: `url(${config.IMAGE_URL}banners/${bannerData.image})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      height: "50vh",
    }
  : {};
  return (
    <>
      <section>
        <div className="head">

        </div>
      </section>
      {/* Hero Section */}

      <section className="hero" style={heroStyle}>
        <div className="hero-content">
          <h1>Explore Our Properties</h1>
          <p>Browse our complete catalog of verified listings—apartments, houses, commercial spaces, and more</p>
        </div>
      </section>

      {/* Featured Properties */}
      <section className="featured">
        <h2>Available Listings</h2>
        <div className="row mt-5 p-5">
          {properties.length === 0 && !loading && (
            <div className="col-12 text-center py-6">
              <p className="mb-3">No properties found right now.</p>
              <Link to="/contact" className="btn btn-primary">Contact Us to list a property</Link>
            </div>
          )}

          {properties.map((p) => {
            const firstImage = p.image?.includes(",")? p.image.split(",")[0]: p.image || 'placeholder.png';
            return(
              <div className="col-md-4 p-4" key={p._id}>
                <Card>
                  <Card.Img variant="top" src={`${config.IMAGE_URL}property/${firstImage}`} className="image" />
                  <Card.Body>
                    <Card.Title>{p.name}</Card.Title>
                    <Card.Text>
                      {p.address}
                    </Card.Text>
                    <Button variant="primary" onClick={()=>{detailPage(p._id)}}>View</Button>
                  </Card.Body>
                </Card>
              </div>
            );

          })}
        </div>
      </section>


    </>
  );
};

export default Property;
